import { render, staticRenderFns } from "./ChildPage.vue?vue&type=template&id=0ae9d4ef&scoped=true&"
import script from "./ChildPage.vue?vue&type=script&lang=js&"
export * from "./ChildPage.vue?vue&type=script&lang=js&"
import style0 from "./ChildPage.vue?vue&type=style&index=0&id=0ae9d4ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae9d4ef",
  null
  
)

export default component.exports